import { Default } from "../../components/Default/Default";
import { MixQualificationTab } from "./components/MixQualification/MixQualification";
import { SYSTEM_COLORS } from "../../components/system.colors";

// página "Qualificação de MIX" 
export function MixQualificationScreen() {
  return (
    <Default fullPage>
      <div style={{
        padding: "16px 28px", backgroundColor: SYSTEM_COLORS.WHITE.ALABASTER,
        display: "flex", flexDirection: "column", flex: 1, minHeight: 0,
        fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif",
        boxSizing: "border-box", width: "calc(100% - 72px)", overflow: "hidden",
        marginLeft: 72,
      }}>
        {/* título */}
        <hgroup style={{ marginBottom: 14, flexShrink: 0 }}>
          <h1 style={{ fontSize: "22px", fontWeight: "700", color: "#1a1a1a", margin: 0, letterSpacing: "-0.3px" }}>
            Qualificação de MIX
          </h1>
          <p style={{ fontSize: "13px", color: "#999", margin: "3px 0 0" }}>
            Análise de sortimento por grupo de produtos — ranking de rede e plano por loja
          </p>
        </hgroup>

        <MixQualificationTab />
      </div>
    </Default>
  );
}
